import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "sidebarWidth"
const DEFAULT_WIDTH = "33.33%"
const MIN_WIDTH_PX = 280
const MAX_WIDTH_VW = 50

export default class extends Controller {
  static targets = ["handle"]

  connect() {
    this.restoreWidth()
    this.boundMove = this.move.bind(this)
    this.boundStop = this.stop.bind(this)
  }

  disconnect() {
    this.cleanup()
  }

  start(event) {
    event.preventDefault()
    this.dragging = true
    this.handleTarget.classList.add("active")
    document.body.classList.add("resizing")
    // Disable sidebar transition during drag for smooth resize
    this.element.style.transition = "none"

    window.addEventListener("pointermove", this.boundMove)
    window.addEventListener("pointerup", this.boundStop)
  }

  move(event) {
    if (!this.dragging) return

    const containerRight = window.innerWidth
    const newWidth = containerRight - event.clientX
    const maxWidthPx = window.innerWidth * (MAX_WIDTH_VW / 100)
    const clamped = Math.min(Math.max(newWidth, MIN_WIDTH_PX), maxWidthPx)

    this.element.style.width = `${clamped}px`
  }

  stop() {
    if (!this.dragging) return
    this.dragging = false
    this.handleTarget.classList.remove("active")
    document.body.classList.remove("resizing")
    // Re-enable transition
    this.element.style.transition = ""

    this.persistWidth()
    this.cleanup()
  }

  restoreWidth() {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved) {
      this.element.style.width = saved
    } else {
      this.element.style.width = DEFAULT_WIDTH
    }
  }

  persistWidth() {
    localStorage.setItem(STORAGE_KEY, this.element.style.width)
  }

  cleanup() {
    window.removeEventListener("pointermove", this.boundMove)
    window.removeEventListener("pointerup", this.boundStop)
  }
}
